<template lang="pug">
.custom-date-picker-single
  //- input(
  //-   type='date'
  //-   :value='value'
  //-   @input='$emit(`input`, $event.target.value)'
  //- )
  button.rounded.transparent-button.small(@click='showModal')
    .d-flex.align-items-center.text-medium.px-1
      span {{ formattedPreviewDate }}
      i.fa.fa-angle-down.ml-2(style='color: #0092C9')

  .upa-modal
    modal(
      :name='modalName'
      width='384px' height='600px'
      transition='modal-transition'
      :clickToClose='false'
    )
      .h-100.d-flex.flex-column
        //- .custom-header.d-flex.sticky-top
        //-   //- CustomTab.flex-fill(
        //-   //-   :tabItems='tabItems'
        //-   //-   v-model='selectedMode'
        //-   //- )
        //-   button.transparent-button.no-scaling.ml-auto(@click='hideModal(false)')
        //-     i.fa.fa-times(style='font-size: 24px; padding: 12px 16px;')

        .flex-fill.d-flex.flex-column.align-items-center.justify-content-center
          template(v-if='selectedMode === `MODE_DATE`')
            .text-medium(style='opacity: 0.5')
              | เลือกวันที่
            .text-large {{ formattedStartDate }}
            datepicker.mt-4(
              v-model='date'
              :inline='true'
              :language='th'
            )

        .d-flex.justify-content-center.mb-4.py-3
          button.btn.btn-secondary(@click='hideModal(false)')
            | ยกเลิก
          button.btn.btn-upa-secondary.ml-4(@click='hideModal(true)')
            | บันทึก
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { th } from 'vuejs-datepicker/dist/locale';

export default {
  props: {
    value: {
      default: () => ({}),
    },
  },
  computed: {
    formattedPreviewDate() {
      const START = this.$moment(this.value).startOf('day');
      // const END = this.$moment(this.value.to).startOf('day');

      // if (END.diff(START, 'days') === 0) { // if same day
      //   return this.$moment(this.value.from).format('D MMM YYYY');
      // }
      // return `${START.format('D MMM YYYY')} - ${END.format('D MMM YYYY')}`;
      return START.format('D MMM YYYY');
    },
    formattedStartDate() {
      return this.$moment(this.date).format('D MMMM YYYY');
    },
  },
  data: () => ({
    tabItems: {
      MODE_DATE: 'เลือกช่วงเวลาแบบวัน',
      // MODE_MONTH: 'เลือกช่วงเวลาแบบเดือน',
    },
    selectedMode: 'MODE_DATE',

    date: '',
    // endDate: '',

    th,
    modalName: '',
  }),
  mounted() {
    if (!this.value) {
      const DEFAULT_DATE = this.$moment().startOf('month').toDate();
      this.$emit('input', DEFAULT_DATE);
    }

    const randomId = Math.random() * 10000000000;
    this.modalName = `date-picker-${Math.round(randomId)}`;
  },
  methods: {
    showModal() {
      this.date = this.value;
      // this.endDate = this.value.to;
      this.$modal.show(this.modalName);
    },
    hideModal(saveValue = true) {
      if (saveValue) {
        let date;
        // let endDate;

        /* eslint-disable prefer-destructuring */
        if (this.selectedMode === 'MODE_DATE') {
          date = this.date;
          // endDate = this.endDate;
        } else if (this.selectedMode === 'MODE_MONTH') {
          date = this.$moment().set('month', this.startMonth - 1).startOf('month').toDate();
          // endDate = this.$moment().set('month', this.endMonth - 1).endOf('month').toDate();
        }

        this.$emit('input', date);
      }
      this.$modal.hide(this.modalName);
    },
    bridgeGap() {
      Object.keys(this.monthSelected).forEach((key) => {
        if (key >= this.startMonth && key <= this.endMonth) this.monthSelected[key] = true;
      });
    },
    removeGap() {
      let inPeriod = false;
      let foundPeriod = false;
      Object.keys(this.monthSelected).forEach((key) => {
        if (foundPeriod) this.monthSelected[key] = false;
        if (this.monthSelected[key]) {
          inPeriod = true;
        }
        if (inPeriod && !this.monthSelected[key]) {
          inPeriod = false;
          foundPeriod = true;
        }
      });
    },

    // MONTH
    isMonthSelected(monthNo) {
      return this.monthSelected[monthNo];
    },
    toggleMonth(monthNo) {
      const oldNum = Object.values(this.monthSelected).filter(elm => elm).length;
      this.monthSelected[monthNo] = !this.monthSelected[monthNo];
      const newNum = Object.values(this.monthSelected).filter(elm => elm).length;
      if (newNum < oldNum) { // last action was to selected to false
        this.removeGap();
      } else if (newNum > oldNum) {
        this.bridgeGap();
      }
      // console.log(`${this.startMonth} to ${this.endMonth}`);
    },
    // QUARTER
    shouldHighlightQuarter() { // we won't highlight quarter buttons if they are partially selected
      let isPartiallySelected = false;
      [1, 2, 3, 4].forEach((quarter) => {
        if (
          this.monthSelected[((quarter - 1) * 3) + 1]
          || this.monthSelected[((quarter - 1) * 3) + 2]
          || this.monthSelected[((quarter - 1) * 3) + 3]
        ) { // has month selected in quarter
          if (!this.isQuarterSelected(quarter)) {
            isPartiallySelected = true;
          }
        }
      });
      return !isPartiallySelected;
    },
    isQuarterSelected(quarterNo) {
      const QUARTER_END = (quarterNo * 3);
      return this.monthSelected[QUARTER_END]
          && this.monthSelected[QUARTER_END - 1]
          && this.monthSelected[QUARTER_END - 2];
    },
    toggleQuarter(quarterNo) {
      const QUARTER_END = (quarterNo * 3);
      const oldNum = [1, 2, 3, 4].map(this.isQuarterSelected).filter(elm => elm).length;
      if (this.isQuarterSelected(quarterNo)) {
        this.monthSelected[QUARTER_END] = false;
        this.monthSelected[QUARTER_END - 1] = false;
        this.monthSelected[QUARTER_END - 2] = false;
      } else {
        this.monthSelected[QUARTER_END] = true;
        this.monthSelected[QUARTER_END - 1] = true;
        this.monthSelected[QUARTER_END - 2] = true;
      }
      const newNum = [1, 2, 3, 4].map(this.isQuarterSelected).filter(elm => elm).length;
      if (newNum < oldNum) { // last action was to selected to false
        this.removeGap();
      } else if (newNum > oldNum) {
        this.bridgeGap();
      }
    },
  },
  components: {
    Datepicker,
  },
};
</script>

<style lang="scss">
// .custom-date-picker-single {}
.custom-header {
  background: #fff;
}

//
// Datepicker style overrides
//
$date-picker-highlight-color: #0092C9;
.vdp-datepicker__calendar {
  border: none !important;
  transition: all 0.2s;
  font-size: 16px;

  .cell {
    border-radius: $card-border-radius;
    &.day {
      border-radius: 50%;
    }

    &.selected {
      background: rgba($date-picker-highlight-color, 0.25) !important;
      font-weight: bold;
    }

    &.highlight-start {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    &.highlight-end {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    &.highlight-start.highlight-end {
      border-radius: 50%;
    }

    &.highlighted:not(.selected) {
      border-radius: 0;
      background: rgba($date-picker-highlight-color, 0.08) !important;
    }

    &.day-header {
      font-weight: bold;
      font-size: 85% !important;

      // &:first-child {
      //   color: red;
      // }
      // &:last-child(1) {
      //   color: red;
      // }
    }

    // &:hover {
    //   background: rgba($date-picker-highlight-color, 0.5);
    // }
  }
  .cell:not(.blank):not(.disabled).year:hover,
  .cell:not(.blank):not(.disabled).month:hover,
  .cell:not(.blank):not(.disabled).day:hover {
    border: 1px solid transparent!important;
    background: rgba($date-picker-highlight-color, 0.5)!important;
  }
}
</style>
